// Code generated by the Encore v1.56.2 client generator. DO NOT EDIT.

// Disable eslint, jshint, and jslint for this file.
/* eslint-disable */
/* jshint ignore:start */
/*jslint-disable*/

/**
 * BaseURL is the base URL for calling the Encore application's API.
 */
export type BaseURL = string

export const Local: BaseURL = "http://localhost:4000"

/**
 * Environment returns a BaseURL for calling the cloud environment with the given name.
 */
export function Environment(name: string): BaseURL {
    return `https://${name}-drops-46t2.encr.app`
}

/**
 * PreviewEnv returns a BaseURL for calling the preview environment with the given PR number.
 */
export function PreviewEnv(pr: number | string): BaseURL {
    return Environment(`pr${pr}`)
}

const BROWSER = typeof globalThis === "object" && ("window" in globalThis);

/**
 * Client is an API client for the drops-46t2 Encore application.
 */
export default class Client {
    public readonly auth: auth.ServiceClient
    public readonly chat: chat.ServiceClient
    public readonly hello: hello.ServiceClient
    public readonly orders: orders.ServiceClient
    public readonly products: products.ServiceClient
    public readonly profile: profile.ServiceClient
    public readonly protocols: protocols.ServiceClient
    private readonly options: ClientOptions
    private readonly target: string


    /**
     * Creates a Client for calling the public and authenticated APIs of your Encore application.
     *
     * @param target  The target which the client should be configured to use. See Local and Environment for options.
     * @param options Options for the client
     */
    constructor(target: BaseURL, options?: ClientOptions) {
        this.target = target
        this.options = options ?? {}
        const base = new BaseClient(this.target, this.options)
        this.auth = new auth.ServiceClient(base)
        this.chat = new chat.ServiceClient(base)
        this.hello = new hello.ServiceClient(base)
        this.orders = new orders.ServiceClient(base)
        this.products = new products.ServiceClient(base)
        this.profile = new profile.ServiceClient(base)
        this.protocols = new protocols.ServiceClient(base)
    }

    /**
     * Creates a new Encore client with the given client options set.
     *
     * @param options Client options to set. They are merged with existing options.
     **/
    public with(options: ClientOptions): Client {
        return new Client(this.target, {
            ...this.options,
            ...options,
        })
    }
}

/**
 * ClientOptions allows you to override any default behaviour within the generated Encore client.
 */
export interface ClientOptions {
    /**
     * By default the client will use the inbuilt fetch function for making the API requests.
     * however you can override it with your own implementation here if you want to run custom
     * code on each API request made or response received.
     */
    fetcher?: Fetcher

    /** Default RequestInit to be used for the client */
    requestInit?: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }

    /**
     * Allows you to set the authentication data to be used for each
     * request either by passing in a static object or by passing in
     * a function which returns a new object for each request.
     */
    auth?: auth.AuthParams | AuthDataGenerator
}

export namespace auth {
    /**
     * Define what we extract from the Authorization header
     */
    export interface AuthParams {
        authorization: string
    }

    /**
     * Response type for auth operations
     */
    export interface AuthResponse {
        user: {
            id: string
            email: string
            name: string
        }
        session: {
            token: string
            expiresAt: string
        }
    }

    /**
     * Request magic link - also creates user if not exists
     */
    export interface RequestMagicLinkRequest {
        email: string
        name?: string
        callbackPath?: string
    }

    export interface RequestMagicLinkResponse {
        success: boolean
        message: string
    }

    /**
     * Logout user
     */
    export interface SignOutRequest {
        token: string
    }

    /**
     * Verify magic link token
     */
    export interface VerifyMagicLinkRequest {
        token: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.betterAuthHandler = this.betterAuthHandler.bind(this)
            this.getSession = this.getSession.bind(this)
            this.requestMagicLink = this.requestMagicLink.bind(this)
            this.signOut = this.signOut.bind(this)
            this.verifyMagicLink = this.verifyMagicLink.bind(this)
        }

        /**
         * Raw endpoint to handle all better-auth requests
         */
        public async betterAuthHandler(method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE" | "HEAD" | "OPTIONS" | "TRACE", path: string[], body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/api/auth/${path.map(encodeURIComponent).join("/")}`, body, options)
        }

        /**
         * Get current session info
         */
        public async getSession(): Promise<{
    valid: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/auth/session`)
            return await resp.json() as {
    valid: boolean
}
        }

        public async requestMagicLink(params: RequestMagicLinkRequest): Promise<RequestMagicLinkResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/magic-link`, JSON.stringify(params))
            return await resp.json() as RequestMagicLinkResponse
        }

        public async signOut(params: SignOutRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/signout`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        public async verifyMagicLink(params: VerifyMagicLinkRequest): Promise<AuthResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/magic-link/verify`, JSON.stringify(params))
            return await resp.json() as AuthResponse
        }
    }
}

export namespace chat {
    /**
     * Wrapper for optional responses (Encore doesn't support union with null)
     */
    export interface ChatSubmissionOptionalResponse {
        found: boolean
        submission?: ChatSubmissionResponse
    }

    export interface ChatSubmissionResponse {
        id: string
        userId: string
        data: { [key: string]: any }
        createdAt: string
    }

    /**
     * Submit chat for authenticated users (no magic link)
     */
    export interface SubmitChatAuthenticatedRequest {
        data: { [key: string]: any }
        userAgent?: string
    }

    export interface SubmitChatAuthenticatedResponse {
        success: boolean
        submissionId: string
    }

    /**
     * Submit chat - unified flow: creates user + submission + sends magic link
     */
    export interface SubmitChatRequest {
        email: string
        name?: string
        data: { [key: string]: any }
        userAgent?: string
    }

    export interface SubmitChatResponse {
        success: boolean
        submissionId: string
        message: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getLatestSubmission = this.getLatestSubmission.bind(this)
            this.getSubmission = this.getSubmission.bind(this)
            this.submitChat = this.submitChat.bind(this)
            this.submitChatAuthenticated = this.submitChatAuthenticated.bind(this)
        }

        /**
         * Get latest submission for current user (authenticated)
         */
        public async getLatestSubmission(): Promise<ChatSubmissionOptionalResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/submissions/latest`)
            return await resp.json() as ChatSubmissionOptionalResponse
        }

        public async getSubmission(id: string): Promise<ChatSubmissionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/submissions/${encodeURIComponent(id)}`)
            return await resp.json() as ChatSubmissionResponse
        }

        public async submitChat(params: SubmitChatRequest): Promise<SubmitChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/submissions`, JSON.stringify(params))
            return await resp.json() as SubmitChatResponse
        }

        public async submitChatAuthenticated(params: SubmitChatAuthenticatedRequest): Promise<SubmitChatAuthenticatedResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/submissions/authenticated`, JSON.stringify(params))
            return await resp.json() as SubmitChatAuthenticatedResponse
        }
    }
}

/**
 * hello service responds to requests with a personalized greeting.
 */
export namespace hello {
    export interface Response {
        message: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.get = this.get.bind(this)
        }

        /**
         * This is a simple REST API that responds with a personalized greeting.
         * To call it, run in your terminal:
         * curl http://localhost:4000/hello/World
         */
        public async get(name: string): Promise<Response> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/hello/${encodeURIComponent(name)}`)
            return await resp.json() as Response
        }
    }
}

export namespace orders {
    /**
     * Cancel order (user-facing)
     */
    export interface CancelOrderRequest {
        reason?: string
    }

    export interface CreateOrderRequest {
        protocolId: string
        customer: CustomerInfo
        recurrence: RecurrencePeriod
        monthlyTotalCents: number
        items: OrderItemInput[]
        paymentMethod: string
        hasGeneticsKit?: boolean
    }

    export interface CreateOrderResponse {
        id: string
        status: OrderStatus
        paymentLinkUrl: string
    }

    /**
     * Types for API
     */
    export interface CustomerInfo {
        name: string
        cpf: string
        phone: string
        cep: string
        street: string
        number: string
        complement?: string
        neighborhood: string
        city: string
        state: string
    }

    /**
     * List user's orders
     */
    export interface ListOrdersResponse {
        orders: {
            id: string
            protocolId: string
            status: OrderStatus
            recurrence: RecurrencePeriod
            monthlyTotalCents: number
            totalCents: number
            customerName: string
            periodEndAt?: string
            renewalCancelledAt?: string
            createdAt: string
        }[]
    }

    export interface OrderItemInput {
        productVariantId: string
        productName: string
        variantName: string
        tier: TierType
        priceCents: number
    }

    /**
     * Order item response type
     */
    export interface OrderItemResponse {
        id: string
        productVariantId: string
        productName: string
        variantName: string
        tier: TierType
        priceCents: number
    }

    /**
     * Full order response type
     */
    export interface OrderResponse {
        id: string
        userId: string
        protocolId: string
        status: OrderStatus
        customer: CustomerInfo
        recurrence: RecurrencePeriod
        monthlyTotalCents: number
        totalCents: number
        items: OrderItemResponse[]
        periodEndAt?: string
        renewalCancelledAt?: string
        pagarmeSubscriptionId?: string
        createdAt: string
        updatedAt: string
    }

    export type OrderStatus = "pending_payment" | "paid" | "cancelled" | "expired" | "unpaid"

    export type RecurrencePeriod = "1" | "3" | "6" | "12"

    export type TierType = "custo_beneficio" | "intermediaria" | "recomendado" | "premium"

    /**
     * Update order address
     */
    export interface UpdateAddressRequest {
        cep: string
        street: string
        number: string
        complement?: string
        neighborhood: string
        city: string
        state: string
    }

    /**
     * Update subscription card
     */
    export interface UpdateCardRequest {
        cardToken: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.cancelOrder = this.cancelOrder.bind(this)
            this.createOrder = this.createOrder.bind(this)
            this.getOrder = this.getOrder.bind(this)
            this.listOrders = this.listOrders.bind(this)
            this.pagarmeWebhook = this.pagarmeWebhook.bind(this)
            this.updateOrderAddress = this.updateOrderAddress.bind(this)
            this.updateSubscriptionCard = this.updateSubscriptionCard.bind(this)
        }

        public async cancelOrder(id: string, params: CancelOrderRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/orders/${encodeURIComponent(id)}/cancel`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Create a new order
         */
        public async createOrder(params: CreateOrderRequest): Promise<CreateOrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/orders`, JSON.stringify(params))
            return await resp.json() as CreateOrderResponse
        }

        public async getOrder(id: string): Promise<OrderResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/orders/${encodeURIComponent(id)}`)
            return await resp.json() as OrderResponse
        }

        public async listOrders(): Promise<ListOrdersResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/orders`)
            return await resp.json() as ListOrdersResponse
        }

        /**
         * Pagarme sends webhooks as standard POST requests
         */
        public async pagarmeWebhook(method: "POST", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/orders/webhooks/pagarme`, body, options)
        }

        public async updateOrderAddress(id: string, params: UpdateAddressRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/orders/${encodeURIComponent(id)}/address`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        public async updateSubscriptionCard(id: string, params: UpdateCardRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/orders/${encodeURIComponent(id)}/card`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }
    }
}

export namespace products {
    export interface ListProductsResponse {
        products: ProductWithVariantsResponse[]
    }

    /**
     * Types for API responses
     */
    export interface ProductVariantResponse {
        id: string
        tier: TierType
        name: string
        description: string
        priceCents: number
        dosagem: string
        posologia: string
        activeIngredientsJson: {
            name: string
            amount: number | null
            unit: string | null
        }[]
        contraindicationTags: string[]
        interactionTags: string[]
        objectiveTags: string[]
        regulatoryNotes: string | null
    }

    export interface ProductWithVariantsResponse {
        id: string
        name: string
        description: string | null
        category: string
        sortOrder: number
        variants: ProductVariantResponse[]
    }

    export type TierType = "custo_beneficio" | "intermediaria" | "recomendado" | "premium"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getProduct = this.getProduct.bind(this)
            this.listProducts = this.listProducts.bind(this)
        }

        public async getProduct(id: string): Promise<ProductWithVariantsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/products/${encodeURIComponent(id)}`)
            return await resp.json() as ProductWithVariantsResponse
        }

        /**
         * List all active products with their variants
         */
        public async listProducts(): Promise<ListProductsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/products`)
            return await resp.json() as ListProductsResponse
        }
    }
}

export namespace profile {
    export interface DeleteAccountRequest {
        confirmationText: string
    }

    export interface DeleteAccountResponse {
        success: boolean
        deletedAt: string
        emailNotificationSent: boolean
    }

    export interface RequestPrivacyExportResponse {
        success: boolean
        sentTo: string
        requestedAt: string
    }

    export interface UpdateProfileRequest {
        name: string
    }

    export interface UserProfile {
        id: string
        email: string
        name: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.deleteAccount = this.deleteAccount.bind(this)
            this.getProfile = this.getProfile.bind(this)
            this.requestPrivacyExport = this.requestPrivacyExport.bind(this)
            this.updateProfile = this.updateProfile.bind(this)
        }

        public async deleteAccount(params: DeleteAccountRequest): Promise<DeleteAccountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/profile/account/delete`, JSON.stringify(params))
            return await resp.json() as DeleteAccountResponse
        }

        public async getProfile(): Promise<UserProfile> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/profile`)
            return await resp.json() as UserProfile
        }

        public async requestPrivacyExport(): Promise<RequestPrivacyExportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/profile/privacy/export`)
            return await resp.json() as RequestPrivacyExportResponse
        }

        public async updateProfile(params: UpdateProfileRequest): Promise<UserProfile> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/profile`, JSON.stringify(params))
            return await resp.json() as UserProfile
        }
    }
}

export namespace protocols {
    export interface ProductVariantResponse {
        id: string
        tier: TierType
        name: string
        description: string
        priceCents: number
        dosagem: string
        posologia: string
    }

    /**
     * Protocol item with product details
     */
    export interface ProtocolItemWithProduct {
        id: string
        productId: string
        sortOrder: number
        name: string
        description: string | null
        alternatives: ProductVariantResponse[]
    }

    /**
     * Wrapper for optional responses (Encore doesn't support union with null)
     */
    export interface ProtocolOptionalResponse {
        found: boolean
        protocol?: ProtocolWithItemsResponse
    }

    /**
     * Full protocol response with items
     */
    export interface ProtocolWithItemsResponse {
        id: string
        title: string
        description: string | null
        hasGeneticsKit: boolean
        createdAt: string
        items: ProtocolItemWithProduct[]
    }

    /**
     * Types for product variants (from products service)
     */
    export type TierType = "custo_beneficio" | "intermediaria" | "recomendado" | "premium"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getLatestProtocol = this.getLatestProtocol.bind(this)
            this.getProtocol = this.getProtocol.bind(this)
        }

        /**
         * Get user's latest protocol (with lazy generation)
         */
        public async getLatestProtocol(): Promise<ProtocolOptionalResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/protocols/latest`)
            return await resp.json() as ProtocolOptionalResponse
        }

        public async getProtocol(id: string): Promise<ProtocolWithItemsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/protocols/${encodeURIComponent(id)}`)
            return await resp.json() as ProtocolWithItemsResponse
        }
    }
}



function encodeQuery(parts: Record<string, string | string[]>): string {
    const pairs: string[] = []
    for (const key in parts) {
        const val = (Array.isArray(parts[key]) ?  parts[key] : [parts[key]]) as string[]
        for (const v of val) {
            pairs.push(`${key}=${encodeURIComponent(v)}`)
        }
    }
    return pairs.join("&")
}

// makeRecord takes a record and strips any undefined values from it,
// and returns the same record with a narrower type.
// @ts-ignore - TS ignore because makeRecord is not always used
function makeRecord<K extends string | number | symbol, V>(record: Record<K, V | undefined>): Record<K, V> {
    for (const key in record) {
        if (record[key] === undefined) {
            delete record[key]
        }
    }
    return record as Record<K, V>
}

function encodeWebSocketHeaders(headers: Record<string, string>) {
    // url safe, no pad
    const base64encoded = btoa(JSON.stringify(headers))
      .replaceAll("=", "")
      .replaceAll("+", "-")
      .replaceAll("/", "_");
    return "encore.dev.headers." + base64encoded;
}

class WebSocketConnection {
    public ws: WebSocket;

    private hasUpdateHandlers: (() => void)[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        let protocols = ["encore-ws"];
        if (headers) {
            protocols.push(encodeWebSocketHeaders(headers))
        }

        this.ws = new WebSocket(url, protocols)

        this.on("error", () => {
            this.resolveHasUpdateHandlers();
        });

        this.on("close", () => {
            this.resolveHasUpdateHandlers();
        });
    }

    resolveHasUpdateHandlers() {
        const handlers = this.hasUpdateHandlers;
        this.hasUpdateHandlers = [];

        for (const handler of handlers) {
            handler()
        }
    }

    async hasUpdate() {
        // await until a new message have been received, or the socket is closed
        await new Promise((resolve) => {
            this.hasUpdateHandlers.push(() => resolve(null))
        });
    }

    on(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.addEventListener(type, handler);
    }

    off(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.removeEventListener(type, handler);
    }

    close() {
        this.ws.close();
    }
}

export class StreamInOut<Request, Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamIn<Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamOut<Request, Response> {
    public socket: WebSocketConnection;
    private responseValue: Promise<Response>;

    constructor(url: string, headers?: Record<string, string>) {
        let responseResolver: (_: any) => void;
        this.responseValue = new Promise((resolve) => responseResolver = resolve);

        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            responseResolver(JSON.parse(event.data))
        });
    }

    async response(): Promise<Response> {
        return this.responseValue;
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }
}
// CallParameters is the type of the parameters to a method call, but require headers to be a Record type
type CallParameters = Omit<RequestInit, "method" | "body" | "headers"> & {
    /** Headers to be sent with the request */
    headers?: Record<string, string>

    /** Query parameters to be sent with the request */
    query?: Record<string, string | string[]>
}

// AuthDataGenerator is a function that returns a new instance of the authentication data required by this API
export type AuthDataGenerator = () =>
  | auth.AuthParams
  | Promise<auth.AuthParams | undefined>
  | undefined;

// A fetcher is the prototype for the inbuilt Fetch function
export type Fetcher = typeof fetch;

const boundFetch = fetch.bind(this);

class BaseClient {
    readonly baseURL: string
    readonly fetcher: Fetcher
    readonly headers: Record<string, string>
    readonly requestInit: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }
    readonly authGenerator?: AuthDataGenerator

    constructor(baseURL: string, options: ClientOptions) {
        this.baseURL = baseURL
        this.headers = {}

        // Add User-Agent header if the script is running in the server
        // because browsers do not allow setting User-Agent headers to requests
        if (!BROWSER) {
            this.headers["User-Agent"] = "drops-46t2-Generated-TS-Client (Encore/v1.56.2)";
        }

        this.requestInit = options.requestInit ?? {};

        // Setup what fetch function we'll be using in the base client
        if (options.fetcher !== undefined) {
            this.fetcher = options.fetcher
        } else {
            this.fetcher = boundFetch
        }

        // Setup an authentication data generator using the auth data token option
        if (options.auth !== undefined) {
            const auth = options.auth
            if (typeof auth === "function") {
                this.authGenerator = auth
            } else {
                this.authGenerator = () => auth
            }
        }
    }

    async getAuthData(): Promise<CallParameters | undefined> {
        let authData: auth.AuthParams | undefined;

        // If authorization data generator is present, call it and add the returned data to the request
        if (this.authGenerator) {
            const mayBePromise = this.authGenerator();
            if (mayBePromise instanceof Promise) {
                authData = await mayBePromise;
            } else {
                authData = mayBePromise;
            }
        }

        if (authData) {
            const data: CallParameters = {};

            data.headers = makeRecord<string, string>({
                authorization: authData.authorization,
            });

            return data;
        }

        return undefined;
    }

    // createStreamInOut sets up a stream to a streaming API endpoint.
    async createStreamInOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamInOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamInOut(this.baseURL + path + queryString, headers);
    }

    // createStreamIn sets up a stream to a streaming API endpoint.
    async createStreamIn<Response>(path: string, params?: CallParameters): Promise<StreamIn<Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamIn(this.baseURL + path + queryString, headers);
    }

    // createStreamOut sets up a stream to a streaming API endpoint.
    async createStreamOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamOut(this.baseURL + path + queryString, headers);
    }

    // callTypedAPI makes an API call, defaulting content type to "application/json"
    public async callTypedAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        return this.callAPI(method, path, body, {
            ...params,
            headers: { "Content-Type": "application/json", ...params?.headers }
        });
    }

    // callAPI is used by each generated API method to actually make the request
    public async callAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        let { query, headers, ...rest } = params ?? {}
        const init = {
            ...this.requestInit,
            ...rest,
            method,
            body: body ?? null,
        }

        // Merge our headers with any predefined headers
        init.headers = {...this.headers, ...init.headers, ...headers}

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                init.headers = {...init.headers, ...authData.headers};
            }
        }

        // Make the actual request
        const queryString = query ? '?' + encodeQuery(query) : ''
        const response = await this.fetcher(this.baseURL+path+queryString, init)

        // handle any error responses
        if (!response.ok) {
            // try and get the error message from the response body
            let body: APIErrorResponse = { code: ErrCode.Unknown, message: `request failed: status ${response.status}` }

            // if we can get the structured error we should, otherwise give a best effort
            try {
                const text = await response.text()

                try {
                    const jsonBody = JSON.parse(text)
                    if (isAPIErrorResponse(jsonBody)) {
                        body = jsonBody
                    } else {
                        body.message += ": " + JSON.stringify(jsonBody)
                    }
                } catch {
                    body.message += ": " + text
                }
            } catch (e) {
                // otherwise we just append the text to the error message
                body.message += ": " + String(e)
            }

            throw new APIError(response.status, body)
        }

        return response
    }
}

/**
 * APIErrorDetails represents the response from an Encore API in the case of an error
 */
interface APIErrorResponse {
    code: ErrCode
    message: string
    details?: any
}

function isAPIErrorResponse(err: any): err is APIErrorResponse {
    return (
        err !== undefined && err !== null &&
        isErrCode(err.code) &&
        typeof(err.message) === "string" &&
        (err.details === undefined || err.details === null || typeof(err.details) === "object")
    )
}

function isErrCode(code: any): code is ErrCode {
    return code !== undefined && Object.values(ErrCode).includes(code)
}

/**
 * APIError represents a structured error as returned from an Encore application.
 */
export class APIError extends Error {
    /**
     * The HTTP status code associated with the error.
     */
    public readonly status: number

    /**
     * The Encore error code
     */
    public readonly code: ErrCode

    /**
     * The error details
     */
    public readonly details?: any

    constructor(status: number, response: APIErrorResponse) {
        // extending errors causes issues after you construct them, unless you apply the following fixes
        super(response.message);

        // set error name as constructor name, make it not enumerable to keep native Error behavior
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        Object.defineProperty(this, 'name', {
            value:        'APIError',
            enumerable:   false,
            configurable: true,
        })

        // fix the prototype chain
        if ((Object as any).setPrototypeOf == undefined) {
            (this as any).__proto__ = APIError.prototype
        } else {
            Object.setPrototypeOf(this, APIError.prototype);
        }

        // capture a stack trace
        if ((Error as any).captureStackTrace !== undefined) {
            (Error as any).captureStackTrace(this, this.constructor);
        }

        this.status = status
        this.code = response.code
        this.details = response.details
    }
}

/**
 * Typeguard allowing use of an APIError's fields'
 */
export function isAPIError(err: any): err is APIError {
    return err instanceof APIError;
}

export enum ErrCode {
    /**
     * OK indicates the operation was successful.
     */
    OK = "ok",

    /**
     * Canceled indicates the operation was canceled (typically by the caller).
     *
     * Encore will generate this error code when cancellation is requested.
     */
    Canceled = "canceled",

    /**
     * Unknown error. An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space. Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * Encore will generate this error code in the above two mentioned cases.
     */
    Unknown = "unknown",

    /**
     * InvalidArgument indicates client specified an invalid argument.
     * Note that this differs from FailedPrecondition. It indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * This error code will not be generated by the gRPC framework.
     */
    InvalidArgument = "invalid_argument",

    /**
     * DeadlineExceeded means operation expired before completion.
     * For operations that change the state of the system, this error may be
     * returned even if the operation has completed successfully. For
     * example, a successful response from a server could have been delayed
     * long enough for the deadline to expire.
     *
     * The gRPC framework will generate this error code when the deadline is
     * exceeded.
     */
    DeadlineExceeded = "deadline_exceeded",

    /**
     * NotFound means some requested entity (e.g., file or directory) was
     * not found.
     *
     * This error code will not be generated by the gRPC framework.
     */
    NotFound = "not_found",

    /**
     * AlreadyExists means an attempt to create an entity failed because one
     * already exists.
     *
     * This error code will not be generated by the gRPC framework.
     */
    AlreadyExists = "already_exists",

    /**
     * PermissionDenied indicates the caller does not have permission to
     * execute the specified operation. It must not be used for rejections
     * caused by exhausting some resource (use ResourceExhausted
     * instead for those errors). It must not be
     * used if the caller cannot be identified (use Unauthenticated
     * instead for those errors).
     *
     * This error code will not be generated by the gRPC core framework,
     * but expect authentication middleware to use it.
     */
    PermissionDenied = "permission_denied",

    /**
     * ResourceExhausted indicates some resource has been exhausted, perhaps
     * a per-user quota, or perhaps the entire file system is out of space.
     *
     * This error code will be generated by the gRPC framework in
     * out-of-memory and server overload situations, or when a message is
     * larger than the configured maximum size.
     */
    ResourceExhausted = "resource_exhausted",

    /**
     * FailedPrecondition indicates operation was rejected because the
     * system is not in a state required for the operation's execution.
     * For example, directory to be deleted may be non-empty, an rmdir
     * operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FailedPrecondition, Aborted, and Unavailable:
     *  (a) Use Unavailable if the client can retry just the failing call.
     *  (b) Use Aborted if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FailedPrecondition if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FailedPrecondition
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FailedPrecondition if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     *
     * This error code will not be generated by the gRPC framework.
     */
    FailedPrecondition = "failed_precondition",

    /**
     * Aborted indicates the operation was aborted, typically due to a
     * concurrency issue like sequencer check failures, transaction aborts,
     * etc.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     */
    Aborted = "aborted",

    /**
     * OutOfRange means operation was attempted past the valid range.
     * E.g., seeking or reading past end of file.
     *
     * Unlike InvalidArgument, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate InvalidArgument if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OutOfRange if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FailedPrecondition and
     * OutOfRange. We recommend using OutOfRange (the more specific
     * error) when it applies so that callers who are iterating through
     * a space can easily look for an OutOfRange error to detect when
     * they are done.
     *
     * This error code will not be generated by the gRPC framework.
     */
    OutOfRange = "out_of_range",

    /**
     * Unimplemented indicates operation is not implemented or not
     * supported/enabled in this service.
     *
     * This error code will be generated by the gRPC framework. Most
     * commonly, you will see this error code when a method implementation
     * is missing on the server. It can also be generated for unknown
     * compression algorithms or a disagreement as to whether an RPC should
     * be streaming.
     */
    Unimplemented = "unimplemented",

    /**
     * Internal errors. Means some invariants expected by underlying
     * system has been broken. If you see one of these errors,
     * something is very broken.
     *
     * This error code will be generated by the gRPC framework in several
     * internal error conditions.
     */
    Internal = "internal",

    /**
     * Unavailable indicates the service is currently unavailable.
     * This is a most likely a transient condition and may be corrected
     * by retrying with a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     *
     * This error code will be generated by the gRPC framework during
     * abrupt shutdown of a server process or network connection.
     */
    Unavailable = "unavailable",

    /**
     * DataLoss indicates unrecoverable data loss or corruption.
     *
     * This error code will not be generated by the gRPC framework.
     */
    DataLoss = "data_loss",

    /**
     * Unauthenticated indicates the request does not have valid
     * authentication credentials for the operation.
     *
     * The gRPC framework will generate this error code when the
     * authentication metadata is invalid or a Credentials callback fails,
     * but also expect authentication middleware to generate it.
     */
    Unauthenticated = "unauthenticated",
}
